import styled from 'styled-components';

import {toolbarStyle} from 'styles';

export const Container = styled.div`
  ${toolbarStyle};
`;

export const Left = styled.div``;

export const MenuItems = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export const Right = styled.div``;
